
import { Language } from '../types';

type Translations = {
  [key in Language]: {
    [key: string]: string;
  };
};

export const translations: Translations = {
  vi: {
    // Header
    home: 'Trang Chủ',
    shop: 'Cửa Hàng',
    about: 'Về Chúng Tôi',
    blog: 'Blog',
    contact: 'Liên Hệ',
    searchPlaceholder: 'Tìm kiếm sản phẩm...',

    // Footer
    slogan: 'Đồng hành cùng bạn trong hành trình chăm sóc thú cưng nhỏ!',
    explore: 'Khám phá',
    newProducts: 'Sản phẩm mới',
    savingCombos: 'Combo tiết kiệm',
    careBlog: 'Blog chăm sóc',
    support: 'Hỗ trợ',
    shippingPolicy: 'Chính sách vận chuyển',
    returnPolicy: 'Đổi trả hàng',
    contactInfo: 'Liên hệ',
    rights: '© 2026 Squeaky Town. Đã đăng ký bản quyền.',

    // Breadcrumbs & SEO
    breadcrumbHome: 'Trang chủ',
    breadcrumbShop: 'Cửa hàng',
    breadcrumbBlog: 'Kho kiến thức',
    relatedProducts: 'Sản phẩm cùng chuyên mục',
    relatedArticles: 'Kiến thức liên quan',
    viewProductDetail: 'Xem chi tiết sản phẩm',
    shopByCategory: 'Mua sắm theo danh mục',
    exploreMoreCategories: 'Khám phá các danh mục khác',

    // Home
    heroTag: 'Chuyên gia dinh dưỡng',
    heroTitle: 'Ươm Mầm Sức Khỏe',
    heroDesc: '100% tự nhiên cho thỏ, bọ ú và các bé thú cưng nhỏ của bạn.',
    ctaOrder: 'Liên Hệ Đặt Hàng',
    featuredTitle: 'Sản phẩm nổi bật',
    featuredSub: 'Những lựa chọn tốt nhất cho sức khỏe thú cưng.',
    viewAll: 'Xem tất cả',
    blogSectionTitle: 'Kiến thức & Chia sẻ',
    blogSectionSub: 'Cùng Squeaky Town chăm sóc bé yêu đúng cách.',
    viewAllBlogs: 'Xem tất cả bài viết',
    noRecentArticles: 'Chưa có bài viết mới.',
    founderTagline: 'Dinh dưỡng chuẩn Mỹ cho Pet Việt',
    readArticle: 'Đọc bài viết',

    // Features
    vetApproved: 'AN TOÀN',
    vetDesc: 'Sản phẩm có chọn lọc\nvà phù hợp với thú nhỏ',
    natural: 'CÁ NHÂN HÓA',
    naturalDesc: 'Thiết lập chế độ ăn\nphù hợp từng giai đoạn',
    shipping: 'GIAO HÀNG NHANH',
    shippingDesc: 'Giao hàng toàn quốc\nnhanh chóng',

    // Shop
    shopTitle: 'CỬA HÀNG THÚ ĂN CỎ',
    shopDesc: 'Sản phẩm được chọn lọc, phù hợp và an toàn dành cho các dòng thú nhạy cảm',
    filterAll: 'Tất cả',
    filterHay: 'Cỏ Khô',
    filterPellets: 'Thức ăn nén',
    filterTreats: 'Bánh thưởng',
    filterToys: 'Đồ chơi & Phụ kiện',
    filterSupplements: 'Thực phẩm bổ sung',
    filterBedding: 'Lót chuồng',
    showing: 'Hiển thị',
    of: 'trong',
    products: 'sản phẩm',
    sort: 'Sắp xếp:',
    sortPopular: 'Phổ biến nhất',
    sortNewest: 'Mới nhất',
    sortPriceAsc: 'Giá tăng dần',
    sortPriceDesc: 'Giá giảm dần',
    contactEmail: 'Mua',
    newsletterTitle: 'BẠN CẦN TƯ VẤN THÊM?',
    newsletterDesc: 'Nhắn tin hoặc gửi email để được tư vấn chế độ ăn hợp lý cho bé cưng của bạn!',
    emailPlaceholder: 'Email của bạn',
    subscribe: 'Gửi',
    orderFor: 'Đặt hàng sản phẩm',
    noProductsFound: 'Không tìm thấy sản phẩm.',

    // Blog Page
    blogPageTitle: 'Kho Kiến Thức Squeaky Town',
    blogPageSub: 'Lời khuyên từ kinh nghiệm thực tế, kiến thức khoa học sẽ kéo dài tuổi thọ cho bé cưng của bạn!',
    readMore: 'Đọc tiếp',
    backToBlog: 'Trở về Blog',

    // About Page
    aboutHeroTag: 'Câu chuyện thương hiệu',
    aboutHeroTitle: 'Squeaky Town',
    aboutHeroDesc: 'Nơi tình yêu thú nhỏ được phát triển và nuôi dưỡng dựa trên kiến thức chăm sóc khoa học!',
    missionTitle: 'Tầm nhìn & Sứ mệnh',
    missionHeadline: 'HẾT LÒNG VÌ SỨC KHOẺ CỦA THÚ CƯNG NHỎ',
    missionP1: 'Chúng tôi hiểu rằng mỗi bé thú cưng nhỏ đều có nhu cầu chăm sóc riêng biệt, vì vậy 𝐒𝐪𝐮𝐞𝐚𝐤𝐲 𝐓𝐨𝐰𝐧 mang đến những sản phẩm chất lượng, an toàn và phù hợp với hệ tiêu hóa đặc thù của các loài thú ăn cỏ.',
    missionQuote: '"Các sản phẩm tối ưu hết mức có thể với tiêu chí AN TOÀN - PHÙ HỢP cho bé, tư vấn dựa trên kinh nghiệm thực tế và kiến thức khoa học."',
    founderTitle: 'Lời nhắn từ nhà sáng lập',
    founderP1: 'Bắt đầu hành trình từ những bé Chuột Lang của mình, tôi yêu những nguồn năng lượng nhỏ này vô cùng! Tôi tin rằng, bất cứ sinh vật nào đều xứng đáng sống hạnh phúc và được chăm sóc đúng cách.',
    founderP2: 'Tại Squeaky Town, bạn không chỉ nhận được những kiến thức suông mà là những chia sẻ từ kinh nghiệm nuôi dưỡng thực tế. Tư vấn dựa trên nền tảng khoa học, kinh nghiệm đúc kết, đặc tính giống loài và tính cách từng bé, vì mỗi cá thể độc lập cần một chế độ chăm sóc khác nhau.\n\nHãy thể hiện mình là chủ nuôi có trách nhiệm thông qua việc tìm hiểu cách chăm sóc thú nhỏ chuẩn khoa học nhé!',
    customerTitle: 'Khách hàng tí hon',
    customerSub: 'Những khoảnh khắc hạnh phúc cùng cỏ khô Squeaky Town.',
    readyToPamper: 'Sẵn sàng chăm sóc bé yêu?',
    joinCommunity: '',
    shopNow: 'Mua sắm ngay',

    // Contact Page
    contactPageTitle: 'Liên hệ với chúng tôi',
    contactPageDesc: 'Chúng tôi rất mong nhận được phản hồi từ bạn. Hãy liên hệ qua email, hotline hoặc mạng xã hội để được hỗ trợ tốt nhất cho thú cưng của bạn.',
    supportChannels: 'Kênh hỗ trợ chính',
    hours: 'Giờ Mở Cửa',
    openDays: 'Mở cửa tất cả các ngày',
    connectSocial: 'Kết nối mạng xã hội',
    followUs: 'Theo dõi Squeaky Town để cập nhật tin tức mới nhất',
    formInquiry: 'Gửi yêu cầu qua Form',
    formName: 'Họ tên',
    formNamePlaceholder: 'Nhập họ tên của bạn',
    formPhone: 'Số điện thoại',
    formPhonePlaceholder: 'Nhập số điện thoại',
    formSubject: 'Sản phẩm đặt hàng',
    formSubjectPlaceholder: 'Bạn đang quan tâm sản phẩm nào?',
    formMessage: 'Lời nhắn',
    formMessagePlaceholder: 'Để lại lời nhắn cho chúng tôi...',
    formSubmit: 'Gửi yêu cầu ngay',
    formSending: 'Đang gửi...',
    formSuccessTitle: 'Đã gửi yêu cầu!',
    formSuccessDesc: 'Squeaky Town sẽ liên hệ lại sớm nhất.',

    // Product Detail
    loadingProduct: 'Đang tải sản phẩm...',
    productNotFound: 'Không tìm thấy sản phẩm này.',
    backToShop: 'Trở về cửa hàng',
    sendEmailInquiry: 'Gửi yêu cầu qua Email',
    naturalCommitment: 'Cam kết 100% tự nhiên & được bác sĩ khuyên dùng.',
    consultMessage: 'Chào Squeaky Town, mình muốn tư vấn đặt sản phẩm: ',

    // Policies
    shippingPolicyTitle: 'Chính sách vận chuyển',
    returnPolicyTitle: 'Chính sách đổi trả',
    lastUpdated: 'Cập nhật lần cuối'
  },
  en: {
    // English translations
    home: 'Home',
    shop: 'Shop',
    about: 'About Us',
    blog: 'Blog',
    contact: 'Contact',
    searchPlaceholder: 'Search products...',
    slogan: 'Accompanying your small pets health with the best products from nature.',
    explore: 'Explore',
    newProducts: 'New Products',
    savingCombos: 'Saving Combos',
    careBlog: 'Care Blog',
    support: 'Support',
    shippingPolicy: 'Shipping Policy',
    returnPolicy: 'Return Policy',
    contactInfo: 'Contact',
    rights: '© 2026 Squeaky Town. All rights reserved.',
    breadcrumbHome: 'Home',
    breadcrumbShop: 'Shop',
    breadcrumbBlog: 'Knowledge Base',
    relatedProducts: 'Related Products',
    relatedArticles: 'Related Knowledge',
    viewProductDetail: 'View Product Details',
    shopByCategory: 'Shop by Category',
    exploreMoreCategories: 'Explore other categories',
    heroTag: 'Nutrition Expert',
    heroTitle: 'Nurturing Health',
    heroDesc: '100% natural for rabbits, guinea pigs, and your small pets.',
    ctaOrder: 'Contact to Order',
    featuredTitle: 'Featured Products',
    featuredSub: 'The best choices for pet health.',
    viewAll: 'View all',
    blogSectionTitle: 'Knowledge & Sharing',
    blogSectionSub: 'Caring for your little ones the right way.',
    viewAllBlogs: 'View all articles',
    noRecentArticles: 'No recent articles.',
    founderTagline: 'US standard nutrition for Vietnamese pets',
    readArticle: 'Read Article',

    vetApproved: 'Vet Approved',
    vetDesc: 'Formulas carefully reviewed',
    natural: '100% Natural',
    naturalDesc: 'No preservatives, absolutely safe',
    shipping: 'Nationwide Shipping',
    shippingDesc: 'Fast delivery to everywhere',
    shopTitle: 'Squeaky Town Shop',
    shopDesc: 'Selection of the best hay, pellets, and accessories for your small pet\'s health.',
    filterAll: 'All',
    filterHay: 'Hay',
    filterPellets: 'Pellets',
    filterTreats: 'Treats',
    filterToys: 'Toys & Accessories',
    filterSupplements: 'Supplements',
    filterBedding: 'Bedding',
    showing: 'Showing',
    of: 'of',
    products: 'products',
    sort: 'Sort by:',
    sortPopular: 'Most Popular',
    sortNewest: 'Newest',
    sortPriceAsc: 'Price: Low to High',
    sortPriceDesc: 'Price: High to Low',
    contactEmail: 'Buy',
    newsletterTitle: 'Need advice?',
    newsletterDesc: 'Message us or email to receive direct advice from our team of experts.',
    emailPlaceholder: 'Your email',
    subscribe: 'Send',
    orderFor: 'Order for',
    noProductsFound: 'No products found.',
    blogPageTitle: 'Squeaky Town Knowledge Base',
    blogPageSub: 'Expert advice, nutrition guides, and health tips for small pets.',
    readMore: 'Read more',
    backToBlog: 'Back to Blog',
    aboutHeroTag: 'Brand Story',
    aboutHeroTitle: 'About Squeaky Town',
    aboutHeroDesc: 'Where love for our little friends is nurtured through dedication and a scientific foundation.',
    missionTitle: 'Vision & Mission',
    missionHeadline: 'Dedicated to the Health of every herbivore',
    missionP1: 'We believe every small pet, from playful bunnies to gentle guinea pigs, deserves a nutritional standard as close to nature as possible.',
    missionQuote: '"Squeaky Town is not just about selling products; we provide a comprehensive care solution advised by leading veterinary experts."',
    founderTitle: 'Message from the Founder',
    founderP1: 'Squeaky Town started with my very own rabbits. I noticed a lack of truly clean and nutrient-rich hay products in the market.',
    founderP2: 'Our journey involved finding the best fields in the USA. We commit that every product you receive is the best.',
    customerTitle: 'Tiny Customers',
    customerSub: 'Happy moments with Squeaky Town products.',
    readyToPamper: 'Ready to pamper your pet?',
    joinCommunity: 'Join thousands of happy customers who trust Squeaky Town.',
    shopNow: 'Shop Now',
    contactPageTitle: 'Contact Us',
    contactPageDesc: 'We look forward to hearing from you. Contact us via email, hotline, or social media.',
    supportChannels: 'Support Channels',
    hours: 'Opening Hours',
    openDays: 'Open every day',
    connectSocial: 'Connect on Social Media',
    followUs: 'Follow Squeaky Town for the latest news',
    formInquiry: 'Send Web Inquiry',
    formName: 'Full Name',
    formNamePlaceholder: 'Enter your full name',
    formPhone: 'Phone Number',
    formPhonePlaceholder: 'Enter your phone number',
    formSubject: 'Product to Order',
    formSubjectPlaceholder: 'Which product are you interested in?',
    formMessage: 'Message',
    formMessagePlaceholder: 'Leave a message for us...',
    formSubmit: 'Send Inquiry Now',
    formSending: 'Sending...',
    formSuccessTitle: 'Request Sent!',
    formSuccessDesc: 'Squeaky Town will contact you as soon as possible.',
    loadingProduct: 'Loading product...',
    productNotFound: 'Product not found.',
    backToShop: 'Back to shop',
    sendEmailInquiry: 'Send Inquiry via Email',
    naturalCommitment: '100% natural commitment & vet recommended.',
    consultMessage: 'Hi Squeaky Town, I would like to order: ',
    shippingPolicyTitle: 'Shipping Policy',
    returnPolicyTitle: 'Return Policy',
    lastUpdated: 'Last updated'
  }
};
